import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { styled } from '@mui/system';
import Drawer from '@mui/material/Drawer';
import { FOOTER_ROOT_PREFIX } from '../../../../modal/modalStyles';
import { EMBERS_HEADER_HEIGHT_MOBILE } from '../../../../header/headerStyles';
export var ROOT_PREFIX = 'EmbersFiltersModal';
export var ModalFiltersContainer = styled('ul')(_defineProperty({
  listStyleType: 'none',
  marginBlockStart: 0,
  marginBlockEnd: 0,
  paddingInlineStart: 0
}, "&.".concat(ROOT_PREFIX, "-modalContainer"), {
  display: 'flex',
  flexWrap: 'wrap',
  columnGap: 16,
  rowGap: 30,
  alignItems: 'top',
  paddingTop: 10,
  marginTop: -10,
  paddingRight: 16
}));
export var DRAWER_ROOT_PREFIX = 'EmbersFilterDrawer';
export var StyledDrawer = styled(Drawer)({
  '.MuiDrawer-paper': _defineProperty({
    top: EMBERS_HEADER_HEIGHT_MOBILE,
    height: "calc(100vh - ".concat(EMBERS_HEADER_HEIGHT_MOBILE, "px)")
  }, ".".concat(FOOTER_ROOT_PREFIX, "-root"), _defineProperty({
    flexDirection: 'column',
    height: 'auto',
    padding: '16px 24px',
    flexFlow: 'column-reverse',
    paddingBottom: 'calc(16px + env(safe-area-inset-bottom))'
  }, ".".concat(FOOTER_ROOT_PREFIX, "-buttons"), {
    display: 'flex',
    flexDirection: 'column',
    flexFlow: 'column-reverse',
    width: '100%',
    '> button': {
      margin: '8px 0'
    }
  }))
});